import { Outlet } from '@tanstack/react-router'
import { Suspense } from 'react'
import { LoadingDots } from '@/components'
import Header, { type HeaderProps } from '../../header/Header'
import * as styles from './MainPageTemplate.styles'
import { ContentWrapper, FlexWrapper } from './StyledWrappers'

interface Props {
  header?: HeaderProps
}

const MainPageTemplate = ({ header }: Props) => (
  <FlexWrapper css={[styles.masterTemplate]}>
    <ContentWrapper css={styles.masterTemplateWrapper()}>
      <Header {...header} />
      <div css={styles.masterTemplateContent}>
        <main css={styles.masterTemplateChildren()}>
          <Suspense fallback={<LoadingDots fullScreen withoutOverlay />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </ContentWrapper>
  </FlexWrapper>
)

export default MainPageTemplate
